import request from '@/utils/request.js'
const url = 'nsh/odm/api/order/io'
export function transferOrderCreate(data) {
  return request({
    url: `${url}/create-transfer-order`,
    method: 'post',
    data
  })
}
export function transferOrderUpdate(data) {
  return request({
    url: `${url}/update-transfer-order`,
    method: 'put',
    data
  })
}
export function transferOrderSearch(data) {
  return request({
    url: `${url}/paging-search-transfer`,
    method: 'post',
    data
  })
}
export function transferOrderUpdateStatus(data) {
  return request({
    url: `${url}/change-status-transfer-order`,
    method: 'post',
    data
  })
}
export function transferOrderInfoById(data) {
  return request({
    url: `${url}/get-transfer-by-id/${data.id}`,
    method: 'get',
    data
  })
}